import { ALL_BLOGS, AUTHOR, CATEGORY, QUERY } from './actionTypes';
import initialState from './initialState';

const filterReducer = (state = initialState, action) => {
    switch (action.type) {
        case ALL_BLOGS:
            return {
                ...state,
                filters: {
                    ...state,
                    category: 'All',
                    author: 'All',
                    query: ''
                }
            };

        case AUTHOR:
            return {
                ...state,
                filters: {
                    ...state.filters,
                    author: action.payload
                }
            };

        case CATEGORY:
            return {
                ...state,
                filters: {
                    ...state.filters,
                    category: action.payload
                }
            };

        case QUERY:
            return {
                ...state,
                filters: {
                    ...state.filters,
                    query: action.payload
                }
            };

        default:
            return state;
    }
};

export default filterReducer;
